// 3_pages/ordering_process_3.js
// Checkout step 3 (body.id--17): lays contact info and billing address into a custom
// grid, relocates note/company/shipping fields, and relabels the billing heading.

export function init() {
	if (!document.body.classList.contains("id--17")) return;

	createGridSystemInOrderThree();
	editTextOfBillingH4();
}

function createGridSystemInOrderThree() {
	const coContactInformation = document.querySelector(".co-contact-information");
	const coBillingAddress = document.querySelector(".co-billing-address");

	const cartHeader = document.querySelector(".cart-header");

	if (!coContactInformation || !coBillingAddress || !cartHeader) return;

	const movingObjects = [coContactInformation, coBillingAddress];

	const customGridSystemOrderThree = document.createElement("div");
	customGridSystemOrderThree.classList.add("custom-grid-system-order-three");

	movingObjects.forEach((element) => {
		const customGridElement = document.createElement("div");
		customGridElement.classList.add("custom-grid-element-order-three");

		const gridHeader = element.querySelector("h4");
		if (gridHeader) {
			customGridElement.appendChild(gridHeader);
		}

		customGridElement.appendChild(element);
		customGridSystemOrderThree.appendChild(customGridElement);
	});
	cartHeader.insertAdjacentElement("afterend", customGridSystemOrderThree);

	const addNote = document.querySelector("#add-note");
	if (addNote) {
		coContactInformation.appendChild(addNote.parentElement.parentElement);
	}

	const companyShopping = document.querySelector("#company-shopping");
	if (companyShopping) {
		coBillingAddress.appendChild(companyShopping.parentElement);
	}

	const companyInfo = document.querySelector("#company-info");
	if (companyInfo) {
		coBillingAddress.appendChild(companyInfo);
	}

	const anotherShipping = document.querySelector("#another-shipping");
	if (anotherShipping) {
		coBillingAddress.appendChild(anotherShipping.parentElement);
	}
	const shippingAddress = document.querySelector("#shipping-address");
	if (shippingAddress) {
		coBillingAddress.appendChild(shippingAddress);
	}
}

function editTextOfBillingH4() {
	const billingAddressH4 = document.querySelector(".header-billing");
	if (billingAddressH4) {
		billingAddressH4.textContent = window.NAT.translations("dorucovaciAFakturacniAdresa");
	}
}
